// The AI tools sharing question, word for word as the Caffeine tools ask it:
// com.caffeine.mcp's Runtime/Telemetry/Core/ConsentWording.cs and its twin in
// MCPCaffeineTools (Core/TelemetryCore/ConsentWording.cs), question version 3.
// The server keeps no wording, only the version (rapid-api-ai's
// MinQuestionVersion, 3, answered by GET /consent as minQuestionVersion): a
// change to any of these words is a new question, released with a new
// version in both packages, the server's minimum and here, together.
// "Don't share" and "Share" carry equal weight wherever the question is asked.
export const AI_TOOLS_QUESTION_VERSION = 3

export const AI_TOOLS_QUESTION = {
  title: "Help improve EducationXR's AI tools",
  what:
    'Share how the AI tools are used with EducationXR: which tools and actions ran, how long they took, whether ' +
    'they worked, and the notes AI agents write when a tool gets in their way.',
  never:
    'We never collect your course content or your prompts or conversations. Names and file paths are removed from ' +
    'the little free text there is. Shared data is linked to your EducationXR account and organization and is used ' +
    'to improve our AI tools, including the prompts they use.',
  account:
    'Your choice is saved on your EducationXR account and applies on every computer you sign in on. Change it any ' +
    "time in the tools' settings, where you can also see what has been shared. If you stop sharing, nothing more is " +
    'collected and what you already shared is no longer linked to your account.'
}

export const AI_TOOLS_ANSWERS = {
  dontShare: "Don't share",
  share: 'Share',
  stopSharing: 'Stop sharing'
}
